<div (click)="travelerModal.close()">

    <div class="modal-container flight-modal-container filter-modal1 modalAirportFilterInfo1"
        (click)="$event.stopPropagation()" style="display: block !important;">
        <!-- Desktop Close Button -->
        <div class="desktop-close-button" (click)="travelerModal.close()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                    fill="#323232" />
            </svg>
        </div>

        <!-- Mobile Header - Only visible on mobile -->
        <div class="mobile-modal-header">
            <svg xmlns="http://www.w3.org/2000/svg" (click)="travelerModal.close()" width="24" height="24"
                viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_1308_9918)">
                    <path
                        d="M19.0005 10.9988H7.83047L12.7105 6.11875C13.1005 5.72875 13.1005 5.08875 12.7105 4.69875C12.3205 4.30875 11.6905 4.30875 11.3005 4.69875L4.71047 11.2888C4.32047 11.6788 4.32047 12.3087 4.71047 12.6987L11.3005 19.2888C11.6905 19.6788 12.3205 19.6788 12.7105 19.2888C13.1005 18.8988 13.1005 18.2687 12.7105 17.8787L7.83047 12.9987H19.0005C19.5505 12.9987 20.0005 12.5487 20.0005 11.9988C20.0005 11.4488 19.5505 10.9988 19.0005 10.9988Z"
                        fill="#323232" />
                </g>
                <defs>
                    <clipPath id="clip0_1308_9918">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>

            <h2 class="mobile-modal-title">{{'search.Selecttraveler' | translate }}s</h2>
        </div>

        <!-- Search Bar -->
        <div class="traveler-search-bar">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                class="search-icon">
                <path
                    d="M14.2939 12.5786H13.3905L13.0703 12.2699C14.191 10.9663 14.8656 9.27387 14.8656 7.43282C14.8656 3.32762 11.538 0 7.43282 0C3.32762 0 0 3.32762 0 7.43282C0 11.538 3.32762 14.8656 7.43282 14.8656C9.27387 14.8656 10.9663 14.191 12.2699 13.0703L12.5786 13.3905V14.2939L18.2962 20L20 18.2962L14.2939 12.5786ZM7.43282 12.5786C4.58548 12.5786 2.28702 10.2802 2.28702 7.43282C2.28702 4.58548 4.58548 2.28702 7.43282 2.28702C10.2802 2.28702 12.5786 4.58548 12.5786 7.43282C12.5786 10.2802 10.2802 12.5786 7.43282 12.5786Z"
                    fill="#757575" />
            </svg>
            <input type="text" [(ngModel)]="travelerSearchTerm" (input)="filterTravelers()"
                placeholder="{{ 'search.SearchByIDorName' | translate }}" class="traveler-search-input">

        </div>

        <!-- Traveler List -->
        <div class="traveler-list-container">
            <!-- My Self -->
            <div class="traveler-item-wrapper" [class.has-passenger-type]="needsPassengerTypeSelection(mySelfTraveler)">
                <div class="passenger-type-gradient-container" *ngIf="needsPassengerTypeSelection(mySelfTraveler) && searchStringCheck('Myself')">
                    <div class="traveler-item" [class.selected]="isTravelerSelected(mySelfTraveler)"
                        (click)="toggleTravelerSelection(mySelfTraveler)">
                        <input type="checkbox" [checked]="isTravelerSelected(mySelfTraveler)"
                            [disabled]="!canSelectTraveler(mySelfTraveler)">
                        <span class="traveler-name">{{'search.Myself' | translate }} <span
                                *ngIf="isDobPresent(mySelfTraveler)" style="margin-left: 20px;"
                                class="ageCategoryForGuest">{{isDobPresent(mySelfTraveler)}}</span></span>
                        <span class="traveler-id">{{ mySelfTraveler?.employeeIdentifier || mySelfTraveler?.id || ''
                            }}</span>
                    </div>
                    <div class="passenger-type-card" (click)="$event.stopPropagation()">
                        <span class="passenger-type-label">Passenger Type</span>
                        <div class="passenger-type-select-wrapper">
                            <select class="passenger-type-select-styled" [value]="getTravelerAgeGroup(mySelfTraveler)?.id || ''"
                                (change)="setTravelerAgeGroup(mySelfTraveler, $any($event.target).value)">
                                <option value="" disabled>Select</option>
                                <option value="ADT">Adult (12+ yrs)</option>
                                <option value="CHD">Child (2-11 yrs)</option>
                                <option value="INF">Infant (&lt;2 yrs)</option>
                            </select>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="select-chevron">
                                <path d="m6 9 6 6 6-6"></path>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="traveler-item" *ngIf="!needsPassengerTypeSelection(mySelfTraveler) && searchStringCheck('Myself')"
                    [class.selected]="isTravelerSelected(mySelfTraveler)"
                    (click)="toggleTravelerSelection(mySelfTraveler)">
                    <input type="checkbox" [checked]="isTravelerSelected(mySelfTraveler)"
                        [disabled]="!canSelectTraveler(mySelfTraveler)">
                    <span class="traveler-name">{{'search.Myself' | translate }} <span
                            *ngIf="isDobPresent(mySelfTraveler)" style="margin-left: 20px;"
                            class="ageCategoryForGuest">{{isDobPresent(mySelfTraveler)}}</span></span>
                    <span class="traveler-id">{{ mySelfTraveler?.employeeIdentifier || mySelfTraveler?.id || ''
                        }}</span>
                </div>


                <hr class="traveler-divider">

                <!-- Guest Traveler -->
                <div class="traveler-item guest-traveler-item" *ngIf="searchStringCheck('Guest Traveler')">
                    <div class="guest-header" [class.selected]="isGuestTravelerSelected()"
                        (click)="toggleGuestTravelerExpand()">
                        <input type="checkbox" [checked]="isGuestTravelerSelected()"
                            [disabled]="!canSelectGuestTraveler()">
                        <span class="traveler-name">Guest Traveler</span>
                        <span class="traveler-id"><span *ngIf="this.guestCounts['adult']">{{this.guestCounts['adult']}}
                                adult<span *ngIf="this.guestCounts['adult'] >1 ">s</span></span>
                            <span *ngIf="this.guestCounts['child']"><span *ngIf="this.guestCounts['adult']">,</span>
                                {{this.guestCounts['child']}} <span *ngIf="this.guestCounts['child'] == 1">child</span><span
                                    *ngIf="this.guestCounts['child'] > 1">children</span></span>
                            <span *ngIf="this.guestCounts['infant']"><span
                                    *ngIf="this.guestCounts['adult'] || this.guestCounts['child']">,</span>
                                {{this.guestCounts['infant']}} infant<span
                                    *ngIf="this.guestCounts['infant'] >1 ">s</span></span></span>
                    </div>

                    <!-- Guest Traveler Expanded Section -->
                    <div class="guest-expanded-section" *ngIf="guestTravelerExpanded">
                        <!-- Adults -->
                        <div class="innerGuestBox">
                            <div class="passenger-type-row">
                                <span class="passenger-type-label">Adults <br> 
                                  <span class="ageCategoryForGuest" *ngIf="viewMode == 'tab5' || viewMode == 'tab1'">Age 12 years or above</span>
                                  <span class="ageCategoryForGuest" *ngIf="viewMode == 'tab2' || viewMode == 'tab3'">Age 18 years or above</span>
                                </span>

                                <div class="passenger-counter">
                                    <button class="counter-btn" (click)="decrementGuestCount('adult')">-</button>
                                    <span class="counter-value">{{ guestCounts.adult }}</span>
                                    <button class="counter-btn" (click)="incrementGuestCount('adult')">+</button>
                                </div>
                            </div>

                            <!-- Children -->
                            <div class="passenger-type-row"
                                *ngIf="searchService.infantBookingAllowed && (this.viewMode ==='tab1' || this.viewMode ==='tab5')">
                                <span class="passenger-type-label">Children <br> <span class="ageCategoryForGuest">Age
                                        2-11 years</span></span>

                                <div class="passenger-counter">
                                    <button class="counter-btn" (click)="decrementGuestCount('child')">-</button>
                                    <span class="counter-value">{{ guestCounts.child }}</span>
                                    <button class="counter-btn" (click)="incrementGuestCount('child')">+</button>
                                </div>
                            </div>

                            <!-- Infants -->
                            <div class="passenger-type-row"
                                *ngIf="searchService.infantBookingAllowed && (this.viewMode ==='tab1' || this.viewMode ==='tab5')">
                                <span class="passenger-type-label">Infants <br> <span class="ageCategoryForGuest">Age
                                        less than 2 years</span></span>

                                <div class="passenger-counter">
                                    <button class="counter-btn" (click)="decrementGuestCount('infant')">-</button>
                                    <span class="counter-value">{{ guestCounts.infant }}</span>
                                    <button class="counter-btn" (click)="incrementGuestCount('infant')">+</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Divider -->
                <div class="traveler-divider" style="border-top:none !important;"
                    *ngIf="filteredTravelers && filteredTravelers.length > 0">

                    <!-- Other Travelers -->
                    <div class="traveler-item-wrapper" *ngFor="let traveler of filteredTravelers; let i = index"
                        [class.has-passenger-type]="needsPassengerTypeSelection(traveler)">
                        
                        <!-- With Passenger Type Selection -->
                        <div class="passenger-type-gradient-container" *ngIf="needsPassengerTypeSelection(traveler)">
                            <div class="traveler-item" [class.selected]="isTravelerSelected(traveler)"
                                (click)="toggleTravelerSelection(traveler)">
                                <input type="checkbox" [checked]="isTravelerSelected(traveler)"
                                    [disabled]="!canSelectTraveler(traveler)">
                                <span class="traveler-name">{{ traveler.userName }}<span *ngIf="isDobPresent(traveler)"
                                        style="margin-left: 20px;"
                                        class="ageCategoryForGuest">{{isDobPresent(traveler)}}</span></span>
                                <span class="traveler-id">{{ traveler.employeeIdentifier}}</span>
                            </div>
                            <div class="passenger-type-card" (click)="$event.stopPropagation()">
                                <span class="passenger-type-label">Passenger Type</span>
                                <div class="passenger-type-select-wrapper">
                                    <select class="passenger-type-select-styled" [value]="getTravelerAgeGroup(traveler)?.id || ''"
                                        (change)="setTravelerAgeGroup(traveler, $any($event.target).value)">
                                        <option value="" disabled>Select</option>
                                        <option value="ADT">Adult (12+ yrs)</option>
                                        <option value="CHD">Child (2-11 yrs)</option>
                                        <option value="INF">Infant (&lt;2 yrs)</option>
                                    </select>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="select-chevron">
                                        <path d="m6 9 6 6 6-6"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <!-- Without Passenger Type Selection -->
                        <div class="traveler-item" *ngIf="!needsPassengerTypeSelection(traveler)"
                            [class.selected]="isTravelerSelected(traveler)"
                            (click)="toggleTravelerSelection(traveler)">
                            <input type="checkbox" [checked]="isTravelerSelected(traveler)"
                                [disabled]="!canSelectTraveler(traveler)">
                            <span class="traveler-name">{{ traveler.userName }}<span *ngIf="isDobPresent(traveler)"
                                    style="margin-left: 20px;"
                                    class="ageCategoryForGuest">{{isDobPresent(traveler)}}</span></span>
                            <span class="traveler-id">{{ traveler.employeeIdentifier}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Mobile Close Button -->
            <div class="mobile-close-button-container">
                <button class="mobile-close-btn" (click)="travelerModal.close()">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>